import { BUTTON_CELL_ACTION_DISPLAY_NAME } from "./core";
import createDisplayName from "../../../../fabrics/createDisplayName";

export const createDisplayNameForButtonCellActionElement = createDisplayName(
    BUTTON_CELL_ACTION_DISPLAY_NAME,
);
